import PortalClienteService from "services/bases/PortalClienteService";

class NavegacoesService extends PortalClienteService{
    async ListarNavegacoesPorUsuario(){
        return await this.get(`navegacoes/ListarNavegacoes`)
    }
}

export default new NavegacoesService();